import axios from 'axios';
import i18n from '../i18n/es.json';
import { clearSession } from '../utils/authUtils';

const clienteAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
clienteAxios.defaults.withCredentials = true;

const handleValidationErrors = (errorResponse) => {
  try {
    // Si es un ArrayBuffer, intentar decodificarlo
    if (errorResponse?.data instanceof ArrayBuffer) {
      const text = new TextDecoder().decode(new Uint8Array(errorResponse.data));
      try {
        // Try parse text as json
        const json = JSON.parse(text);
        // Return message if exists
        return json?.msg || i18n.defaultErrorMessage;
      } catch (e) {
        // Return plain text if parser fail
        return text;
      }
    }
    const validationErrors = errorResponse?.data?.errors?.map((e) => e.msg);
    if (validationErrors && validationErrors.length > 0) {
      return validationErrors.join('\n');
    }
    return errorResponse?.data?.msg || i18n.defaultErrorMessage;
  } catch (error) {
    return i18n.defaultErrorMessage;
  }
};

clienteAxios.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem('token'));
    if (token) {
      config.headers.Authorization = `Bearer ${JSON.stringify(token)}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

clienteAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.message === 'Network Error' && !error.response) {
      return Promise.reject(i18n.networkError);
    }
    const { status } = error.response;
    if (status) {
      if (status === 401) {
        clearSession(error.response.data.msg || i18n.auth.invalidSession);
      }
      const errorMsg = handleValidationErrors(error.response);
      return Promise.reject(errorMsg);
    }
    return null;
  }
);

export default clienteAxios;
